import { TargetComponents, LeadingStyleGroup } from '../../../types';

export const getTargetComponents = (
  group: LeadingStyleGroup,
): TargetComponents => {
  return {
    leadingGroupInfo: {
      groupId: group.editorPointer.asUniqueKey,
      componentType: group.context.getExtensionType(),
      displayName: group.displayName.component,
    },
    subsetGroupInfos: group.subsetGroups.map((subsetGroup) => ({
      groupId: subsetGroup.editorPointer.asUniqueKey,
      displayName: subsetGroup.displayName.component,
    })),
  };
};
